module.exports = __webpack_public_path__ + "img/main.f30606f7.jpg";